import React from 'react';
import PropTypes from 'prop-types';

import InternalLink from 'components/links/internalLink';

import { StyledCard } from 'styled';
import { CardTitle, CardDesc, StyledCardMainWrapper } from './styled';

const CardLinkList = ({ article, preview, language }) => {
  if (article.data) {
    let imageURL, url, altText;
    const categoryUrl = article.data.category || article.data.aircraft_category
    const docUrl = article.data.url

    if (article.data.card_image && article.data.card_image.url ) {
      imageURL = article.data.card_image.url
      altText = article.data.card_image.alt || ""
    } else {
      imageURL = undefined;
    }

    if (article.type == 'aircraft') {
      let aircraftCat;

      if (article.data.aircraft_category == 'small props'){
        aircraftCat = 'smallprop-aircraft-hire'
      } else if (article.data.aircraft_category == 'small jets'){
        aircraftCat = 'small-jet-hire'
      } else if (article.data.aircraft_category == 'medium jets'){
        aircraftCat = 'medium-jet-hire'
      } else if (article.data.aircraft_category == 'long range jets'){
        aircraftCat = 'longrange-jet-hire'
      } else if (article.data.aircraft_category == 'regional airliners'){
        aircraftCat = 'regional-airliner-hire'
      } else if (article.data.aircraft_category == 'large airliners'){
        aircraftCat = 'vip-airliner-hire'
    } 
      url = `/private-jets/${aircraftCat}/${docUrl}`;
    }
    else { 
      if (!categoryUrl) {
        url = `/${docUrl}`; 
      } else {
        url = `/${categoryUrl}/${docUrl}`; 
      }
    }
    return (
      <StyledCard
        key={docUrl}
        fontColor="rgb(70, 52, 78)"
        marginBottom='20px'
        display={true}
      >
        <InternalLink 
          path={url}
          language={language}
          linkComponent={
            imageURL &&
            <StyledCardMainWrapper>
              <div className="card-image-wrapper">
                <img 
                  src={imageURL} 
                  alt={altText}
                />
              </div>
              <div className="card-body">
                <CardTitle>
                  {article.data.card_title || article.data.post && article.data.post.raw[0].text}
                </CardTitle>
                <CardDesc>
                  {article.data.card_description || article.data.post && article.data.post.raw[1].text}
                </CardDesc>
              </div>
            </StyledCardMainWrapper>
          }
        />
      </StyledCard>
    );
  } else {
    return null
  }
};

export default CardLinkList;

CardLinkList.propTypes = {
  article: PropTypes.object,
  language: PropTypes.string,
  preview: PropTypes.bool
}; 
